import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import { concat } from '@ember/helper';
import { t } from 'ember-intl';
import BvBtn from 'volta/components/bv-btn';
import BvInline from 'volta/components/bv-inline';
import BvStatus from 'volta/components/bv-status';
import BvText from 'volta/components/bv-text';
import CodeDesc from 'volta/components/code-desc';
import tElse from 'volta/helpers/t-else';
import unitMeasure from 'volta/helpers/unit-measure';
import { Statuses as POStatusOptions } from 'volta/models/planning-order';
import type { TOC } from '@ember/component/template-only';
import type { TEntityType } from 'volta/models/types/entity-types';
import type { TPOStatus, TPOStatusOption, TPOValidationStatus } from 'volta/models/types/planning-order';
interface POPayload {
    linkedEntityType: TEntityType;
    dueDate: string;
    orderLine?: string;
    orderNum?: string;
    partCode: string;
    partUnitMeasure: string;
    reorderQty: number;
    skuId: string;
    skuDescription?: string;
    status: TPOStatus;
    validationStatus?: TPOValidationStatus;
    warehouseCode: string;
}
interface TasksKitListPoPayloadSignature {
    Args: {
        id: string;
        payload: POPayload;
    };
    Element: HTMLElement;
}
const getOption = (status: TPOStatus): TPOStatusOption =>{
    return POStatusOptions[status];
};
const TasksKitListPoPayloadComponent: TOC<TasksKitListPoPayloadSignature> = template_fd9b2463e5f141cfb5666b64daa1f11a(`
  <BvBtn
    @route='protected.po-workbench.line.tasks'
    @routeModel={{@id}}
    @subtle={{true}}
    @size='sm'
    ...attributes
  >
    <BvInline @gap='2' @wrap={{false}} @blockAlign='center'>
      {{#let (getOption @payload.status) as |statusOption|}}
        <BvStatus
          @status={{tElse statusOption.label statusOption.key}}
          @progress={{statusOption.progress}}
          @color={{statusOption.color}}
        />
      {{/let}}
      {{#if @payload.orderNum}}
        <CodeDesc @code={{concat '#' @payload.orderNum}} @desc={{@payload.orderLine}} />
      {{/if}}
      <span>
        <BvText @text={{@payload.reorderQty}} />
        <BvText
          @text={{unitMeasure @payload.partUnitMeasure}}
          @color='subdued'
          @variant='body-sm'
        />
      </span>
      <BvText @text={{t 'of'}} />
      <BvBtn
        @plain={{true}}
        @size='sm'
        @route='protected.po-workbench.sku'
        @routeModel={{@payload.skuId}}
        @text={{@payload.partCode}}
      />
    </BvInline>
  </BvBtn>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default TasksKitListPoPayloadComponent;
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        'TasksKit::List::PoPayload': typeof TasksKitListPoPayloadComponent;
        'tasks-kit/list/po-payload': typeof TasksKitListPoPayloadComponent;
    }
}
